import { numberFormat } from '../../../../../../lib/format';
import { dashboardT } from '../../../../../../lib/messages';
import { JourneyNodeStatus, journeyNodePercentage, type JourneyNode } from './journeyFlowModel';
import { journeyPercentageLabel, journeyCountLabel } from './journeyFlowPresentation';

export function JourneyNodeDetails({ node }: { node: JourneyNode }) {
  const percentage = journeyNodePercentage(node);
  return (
    <div className="space-y-2">
      <p className="font-semibold">
        {node.label} · {journeyCountLabel(node)}
        {percentage !== null
          ? ` · ${dashboardT('journey.parent', { percentage: journeyPercentageLabel(node, percentage) })}`
          : ''}
      </p>
      <p>
        {node.status === JourneyNodeStatus.Unavailable ? node.availabilityNote : node.description}
      </p>
      {node.attributes ? (
        <p>
          {dashboardT('journey.attempts', {
            count: numberFormat().format(node.attributes.attempts),
          })}{' '}
          ·{' '}
          {dashboardT('journey.duplicates', {
            count: numberFormat().format(node.attributes.possibleDuplicateAttempts),
          })}
        </p>
      ) : null}
      {[
        { label: dashboardT('journey.subtypes'), items: node.subtypes },
        { label: dashboardT('journey.reasons'), items: node.undefinedReasons },
      ].map(({ label, items }) =>
        items?.length ? (
          <div key={label} className="space-y-1">
            <p className="font-medium">{label}</p>
            <dl className="space-y-1">
              {items.map((item) => (
                <div key={item.id} className="flex flex-wrap gap-x-2 gap-y-1">
                  <dt>{item.label}</dt>
                  <dd className="tabular-nums">
                    {numberFormat().format(item.count)}
                    {item.percentage === null
                      ? ''
                      : ` · ${journeyPercentageLabel(item, item.percentage)}`}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        ) : null,
      )}
    </div>
  );
}
